import { boolean, number, object } from "superstruct";

export const ApproverSchema = object({
    id: number(),
    isApproved: boolean(),
});
